import { useState, useEffect, useCallback } from 'react';
import { userPermissionsService } from '../services/users/userPermissionsService';
import { canAccessModule } from '../utils/userPermissions';

/**
 * Per-user module permission state for the logged-in user.
 * Fail-open: while loading or on any error, canAccess() returns true so the
 * UI never flashes a false denial — the backend enforces per-request anyway.
 */
export const usePermissions = () => {
  const [permState, setPermState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    userPermissionsService.getMyPermissions().then((state) => {
      if (active) {
        setPermState(state);
        setLoading(false);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  const canAccess = useCallback(
    (moduleId) => canAccessModule(permState, moduleId),
    [permState]
  );

  return { loading, enabled: permState?.enabled || false, canAccess };
};

export default usePermissions;
